import React, { SVGProps } from "react";
export default function SupUserAnon017(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 5.27444L10 9.93152M18 5.27444V8.90422L16.3979 9.83M18 5.27444L14.7899 3.52219L13.1819 4.47414M10 19.2457L18 14.6228V10.7534M10 19.2457L2 14.6228V5.37717M10 19.2457V15.3762M2 5.37717L10 0.754333L13.1819 2.59298M2 5.37717L5.17593 7.2124M10 9.93152V13.5271M10 9.93152L6.8866 8.20091M5.17593 7.2124V12.671M5.17593 7.2124L13.1819 2.59298M5.17593 12.671L10 15.3762M5.17593 12.671L6.8866 11.7122M10 15.3762L18 10.7534M18 10.7534L16.3979 9.83M10 13.5271L6.8866 11.7122M10 13.5271L16.3979 9.83M6.8866 8.20091V11.7122M6.8866 8.20091L13.1819 4.47414M13.1819 2.59298V4.47414"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
